import { FC } from 'react';

import Icon from './image.svg';

export const WalletConnectLogo: FC = () => <img src={Icon} alt="wallet-connect logo" />;
